@if (!isMenuOpen()) {
  <button class="floating-feedback-button" data-testid="floating-feedback-button" mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon [svgIcon]="IconNames.ice_message" />
  </button>
}
<mat-menu #menu="matMenu" xPosition="before" yPosition="above">
  <div class="floating-feedback-navigation-container">
    @if ({ dealer: activeDealer(), user: user() }; as data) {
      <button
        class="floating-feedback-navigation-link"
        data-testid="floating-feedback-navigation-button"
        (click)="openFeedbackDialog(data)"
      >
        <mat-icon class="floating-feedback-icon" [svgIcon]="IconNames.ice_message" />
        <span class="floating-feedback-text">Gi tilbakemelding</span>
      </button>
    }
    @if ({ user: user() }; as data) {
      <button
        class="floating-feedback-navigation-link"
        data-testid="floating-error-navigation-button"
        (click)="openErrorDialog(data)"
      >
        <mat-icon class="floating-feedback-icon" [svgIcon]="IconNames.ice_chat" />
        <span class="floating-feedback-text">Meld feil til forhandlersupport</span>
      </button>
    }
  </div>
</mat-menu>
